import { Component, OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFireDatabase } from 'angularfire2/database';
import { Subscription } from 'rxjs';
import { PostService } from '../../_services/post.service';
import { AngularFirestore } from 'angularfire2/firestore';



@Component({
  selector: 'app-entities',
  templateUrl: './entities.component.html',
  styleUrls: ['./entities.component.css'],
})
export class EntitiesComponent implements OnInit {
  type: any;
  sub: Subscription;
  sub1: Subscription;
  uniqueName: string;
  username: string;
  constructor(private afs: AngularFirestore, private route: ActivatedRoute, private postservice: PostService, private cd: ChangeDetectorRef, private router: Router) {

    this.sub = this.route.params.subscribe(params => {
      const url = decodeURIComponent(this.router.url);
      console.log(url)
      this.uniqueName = decodeURIComponent(params["uniqueName"]).split("#")[0].toLowerCase();

      // this.postservice.posts$.next([]);

      this.sub1 = this.afs.collection('entities', ref => ref.where('uniqueName', '==', this.uniqueName).orderBy('type')).valueChanges().subscribe(a => {
        if (a[0]) {
          this.username = a[0]['uniqueName']
          this.type = a[0]['type']
          this.cd.markForCheck();

        }

        else {
          this.router.navigate(["page-not-found"]);

        }
      });


    });



  }

  ngOnInit() {
    // this.uniqueName = this.route.snapshot.paramMap.get('uniqueName');
    // const ref = await this.afs.collection('entities').ref
    //   .where('uniqueName','==',this.uniqueName).orderBy('type').get();

    // if (!ref.empty) {
    //   const list = ref.docs.map((val) => {
    //     return val.data()
    //   });
    //   this.type = list[0].type;
    //   this.username = list[0].uniqueName;
    //   console.log(list)
    // } else {
    //   this.router.navigate(["page-not-found"]);
    // }

  }
  ngOnDestroy() {

    this.sub.unsubscribe();
    this.sub1.unsubscribe();
    // if(this.type === 'brand')
    // this.sub1.unsubscribe();
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/entities/entities.component.ts